import React, { useCallback, useEffect, useState } from 'react'

import { cleanup, defaultInstance } from '../../../data/fetchers'
import { MaintenanceScreen } from '../components'

type Props = {
  children: React.ReactNode
}

export const MaintenanceProvider: React.FC<Props> = ({ children }) => {
  const [isMaintenance, setMaintenance] = useState(false)

  const handleSetMaintenance = useCallback((value: boolean) => {
    setMaintenance(value)
  }, [])

  useEffect(() => {
    // Create a new Axios instance with the handler
    defaultInstance(handleSetMaintenance)

    return () => {
      cleanup()
    }
  }, [handleSetMaintenance])

  if (isMaintenance) {
    return <MaintenanceScreen />
  }

  return <>{children}</>
}
